import request from '@axios'

export function getNotifications() {
  return request({
    url: '/notification',
    method: 'get',
  })
}

export function readAllNotifications() {
  return request({
    url: '/notification/read-all',
    method: 'post',
  })
}

export function sendNotification(data) {
  return request({
    url: '/notification/send',
    method: 'post',
    data: data
  })
}